
import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";


import rootReducer from "./ducks/rootReducer";
import rootSaga from "./sagas/rootSaga";

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const store = createStore(rootReducer, compose(applyMiddleware(...middlewares)));
sagaMiddleware.run(rootSaga);

export default store;
